import Icons from "@/src/components/Icons";
import { useNavigate } from "react-router-dom";
import FoodItem from "./FoodItem";
import SearchFood from "./SearchFood";
import { useEffect, useState } from "react";
import { foodApi } from "@/src/utils/api/food";
import ModalFoodItem from "./ModalFoodItem";

function Food() {
  const [data, setData] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataItem, setDataItem] = useState<any>({});
  const [showModal, setShowModal] = useState<boolean>(false);
  const [reload, setReload] = useState<number>(1);
  let history = useNavigate();

  useEffect(() => {
    foodApi.list().then((res) => {
      const sortedData = res.data.sort((a: any, b: any) => {
        const order: any = { Entree: 1, Side: 2, Etc: 3 };
        if (a.state !== "Active" && b.state === "Active") return 1;
        if (a.state === "Active" && b.state !== "Active") return -1;
        if (order[a.type] === order[b.type]) {
          return b.orderCount - a.orderCount;
        }
        return (order[a.type] || 4) - (order[b.type] || 4);
      });
      setData(sortedData);
    });
  }, [reload]);
  const filteredData = data.filter((item: any) =>
    item.foodName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const onClickItem = (item: any) => {
    setDataItem(item);
    setShowModal(true);
  };
  return (
    <div>
      <h4
        className="title text-xl font-extrabold flex items-center cursor-pointer"
        onClick={() => history("/profile")}
      >
        <Icons name="arrowBack" fill="none" size={40} />
        غذاها
      </h4>
      <SearchFood searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <div className="items gap-5 flex flex-col">
        {filteredData &&
          filteredData.length > 0 &&
          filteredData.map((item: any) => (
            <FoodItem key={item.foodId} data={item} onClick={onClickItem} />
          ))}
      </div>
      <ModalFoodItem
        open={showModal}
        close={() => setShowModal(false)}
        data={dataItem}
        setReload={setReload}
        reload={reload}
      />
    </div>
  );
}

export default Food;
